var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnExternal = function SvgIcnExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.795 2.25h4.21c.409 0 .745.336.745.745v4.21c0 .41-.336.746-.745.746a.749.749 0 0 1-.746-.746V4.808l-6.987 6.973a.742.742 0 0 1-1.053 0 .741.741 0 0 1 0-1.053l6.973-6.987h-2.397a.749.749 0 0 1-.746-.746c0-.409.336-.745.746-.745Zm1.946 7.62c0-.384.337-.7.747-.7s.747.316.762.7v2.83c0 1.69-1.465 3.05-3.253 3.05H5.503c-1.802 0-3.253-1.374-3.253-3.05V7.55c0-1.69 1.465-3.05 3.253-3.05h3.003c.41 0 .748.316.748.7 0 .385-.337.701-.748.701H5.503c-.953 0-1.744.728-1.744 1.635v5.15c0 .894.777 1.635 1.744 1.635h5.494c.953 0 1.744-.728 1.744-1.634V9.87Z",
    fill: "#595959"
  })));
};
export default SvgIcnExternal;